import rules from '../../../constants/businessRules/businessRules';
import { IElement, ISpacer } from '../../../types/content';

/**
 * Updates the padding when all padding is increased or decreased at once
 */
export default <T extends Exclude<IElement, ISpacer>>(content: T, value: number): T => {
    const { paddingLeft, paddingRight, paddingBottom, paddingTop } = content;
    const clampValue = (value > 0) ? rules.MAXIMUM_ALLOWABLE_GUTTER : 0;

    const paddingValues = [paddingLeft, paddingRight, paddingTop, paddingBottom].map((pad) => {
        if (clampValue === 0) {
            return (pad + value < clampValue) ? clampValue : pad + value;
        }
        return (pad + value > clampValue) ? clampValue : pad + value;
    });

    return {
        ...content,
        paddingLeft: paddingValues[0],
        paddingRight: paddingValues[1],
        paddingTop: paddingValues[2],
        paddingBottom: paddingValues[3],
    };
};
